import { useDispatch, useSelector } from "react-redux";
import { guestAccessAttempt } from "../../../features/guest/guestSlice";
import { FrameContent, FrameHeading, LessonsWrapper, Text } from "./TopicsStyle"
import { reading } from "../../../i18n/07_reading";

const lessons = Array.from({ length: 30 }, (_, i) => `Lesson ${i + 1}`);

const Topics = ({ clickLesson, isLessonUnlocked, isGuest }) => {
  const lang = useSelector(state => state.lang.lang)
  const t = reading[lang]


  const dispatch = useDispatch()
  return (
    <FrameContent>
      <FrameHeading>{t.listOfLessons}</FrameHeading>
      <LessonsWrapper>
        {lessons.map((value, index) => {
          const lessonNumber = index + 1
          const unlocked = isLessonUnlocked ? isLessonUnlocked(lessonNumber) : true

          const handleClick = () => {
            if (isGuest) {
              dispatch(guestAccessAttempt());
              return;
            }
            if (!unlocked) return
            clickLesson(lessonNumber)
          }

          return (
            <Text
              key={index}
              onClick={handleClick}
            >
              {value}
            </Text>
          )
        })}
      </LessonsWrapper>
    </FrameContent>
  )
}

export default Topics